import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import { useAppDispatch, useAppSelector } from '../../store';
import { getInvitation, selectInvitationState } from '../../store/entities/invitation';
import { invitationHistoryListActions } from '../../store/entities/invitationHistoryList';
import { FetchState } from '../../store/fetchState';
import { ErrorAlert } from '../common/ErrorAlert';
import { Loader } from '../common/Loader';
import { InvitationEdit } from './Detail/InvitationEdit';

import { invitationListActions, selectInvitationList } from '../../store/entities/invitationList';
import { invitationStateAudActions } from '../../store/entities/invitationStateAud';
import { InvitationDto } from '@api/models/invitation/InvitationDto';
import { invitationService } from '@api/services/services';

export const InvitationDetail: FC = () => {
  const { invitationId } = useParams();
  const invitationState = useAppSelector(selectInvitationState);
  const invitationList = useAppSelector(selectInvitationList);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);

  const changeData = async (data: InvitationDto) => {
    try {
      const auditResponse = await invitationService.getInvitationAudit(data.id!, { page: 0, size: 1 });
      dispatch(invitationStateAudActions.success(auditResponse.data.content?.[0]));
    } catch (err) {
      dispatch(invitationStateAudActions.error());
    }

    //Reload if found in grid with old state.
    //BE can change state if invitation is first open.
    const itemInList = invitationList.data?.content.find((x) => x.id === data.id);
    if (itemInList) {
      if (itemInList.state !== data.state) {
        dispatch(invitationListActions.reload(true));
      }
    }

    return data;
  };

  useEffect(() => {
    const source = axios.CancelToken.source();
    dispatch(getInvitation(invitationId!, changeData, source.token));
    dispatch(invitationHistoryListActions.reload(true));
    setLoading(false);
    return () => source.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitationId]);

  if (loading || invitationState === FetchState.Loading) {
    return <Loader />;
  }

  if (invitationState === FetchState.Error) {
    return <ErrorAlert />;
  }

  return <InvitationEdit />;
};
